import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { DictionaryService } from '@sdbn/appclient';

export class Instruction {
  index: number;
  titleDictionaryKey: string;
  descriptionDictionaryKey: string;
  textDictionaryKey: string;
  checked: boolean;

  constructor(instruction: any) {
    this.index = instruction.index;
    this.titleDictionaryKey = instruction.titleDictionaryKey;
    this.descriptionDictionaryKey = instruction.descriptionDictionaryKey;
    this.textDictionaryKey = instruction.textDictionaryKey;
  }
}

@Component({
  selector: 'app-transport-registration-instructions',
  templateUrl: './transport-registration-instructions.component.html',
  styleUrls: ['./transport-registration-instructions.component.scss']
})
export class TransportRegistrationInstructionsComponent extends AbstractWidgetComponent implements OnInit {

  selectedInstruction: Instruction;

  instructions = new Array<Instruction>();
  instructionsForm: FormGroup;

  constructor(
    public translationService: TranslationService,
    private dictionaryService: DictionaryService,
    private formBuilder: FormBuilder
  ) {
    super();
    this.instructions = this.createInstructionsFromDictionary();
    this.instructionsForm = this.formBuilder.group({
      instructions: this.formBuilder.array(this.instructions.map((instruction, i) => {
        return this.formBuilder.control(false);
      }), (control: AbstractControl) => {
        return control.value.indexOf(false) > -1 ? { notAllChecked: { value: control.value } } : null;
      })
    });

    this.instructionsForm.valueChanges.subscribe(
      values => {
        this.dashboardContext.setContextValue(TerminalContextConstants.transportInstructionsValidityState, this.instructionsForm.valid);
        this.dashboardContext.setContextValue(TerminalContextConstants.instructions, values);
        this.updateInstructionsSelection();
      }
    );
  }

  private updateInstructionsSelection() {
    for (let index = 0; index < this.instructions.length; index++) {
      const instruction = this.instructions.find(i => i.index === (index + 1));
      if (instruction != null) {
        instruction.checked = this.instructionsForm.value.instructions[index];
      }
    }
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    const instructions = this.dashboardContext.getContextValue(TerminalContextConstants.instructions);
    if (instructions != null) {
      this.instructionsForm.reset(instructions);
    }
  }

  public showInstructionDetails(instruction: Instruction) {
    this.selectedInstruction = instruction;
    this.dashboardContext.setContextValue(TerminalContextConstants.transportInstructionsDetailsShownState, true);
  }

  public hideInstructionDetails() {
    this.selectedInstruction = null;
    this.dashboardContext.setContextValue(TerminalContextConstants.transportInstructionsDetailsShownState, false);
  }

  private createInstructionsFromDictionary() {

    const rootKey = 'tmc-yard.widgets.registration-terminal.transport-registration-instructions.instructions';

    const instructions = new Array<Instruction>();

    const keys = this.dictionaryService.getDictionaryKeysStartingWith(rootKey);

    const instructionsByIndex = new Map<string, Instruction>();
    for (const k of keys) {
      const key = k.replace(rootKey + '.', '');
      const parts = key.split('.');

      const index = parts[0];
      const part = parts[1];

      let instruction = instructionsByIndex.get(index);
      if (instruction == null) {
        instruction = new Instruction({ index: +index });
        instructionsByIndex.set(index, instruction);
      }
      if (part === 'title') {
        instruction.titleDictionaryKey = k;
      } else if (part === 'description') {
        instruction.descriptionDictionaryKey = k;
      } else if (part === 'text') {
        instruction.textDictionaryKey = k;
      }
    }
    for (const i of instructionsByIndex.values()) {
      instructions.push(i);
    }

    instructions.sort((a, b) => {
      return a.index - b.index;
    });

    return instructions;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
